<template>
    <div>
        <div v-if="!overview" style="display: flex; justify-content: center; align-items: center;">
            <frm-spinner />
        </div>
        <frm-overview v-else :config="overview" />
    </div>
</template>

<script>
import HandlesErrorResponses from '../mixins/HandlesErrorResponses';
import HandlesJobs from '../mixins/Overview/HandlesJobs';
import HandlesActions from '../mixins/Overview/HandlesActions';

// @vue/component
export default {
    mixins: [HandlesErrorResponses, HandlesJobs, HandlesActions],

    props: {
        job: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            overview: null,
        };
    },

    async mounted() {
        try {
            const data = await this.awaitAndProcessJob(this.job);
            this.overview = data.overview;
        } catch (err) {
            await this.handleErrorResponse(err);
        }
    },
};
</script>
